const generateRandomPassword = (length: number = 10): string =>
	Math.random()
		.toString(36)
		.slice(-length);

export { generateRandomPassword };
